import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, Button, DialogTrigger, Combobox, Option } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import React from "react";

export default function ChangeProductDialog(
    {
        open,
        setOpen
    }: {
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>
    }
) {
    const [ products, setProducts ] = React.useState( [] );

    React.useEffect(
        () => {
            fetch(
                "https://api.violetech.co.uk/v1/flighting/products",
                {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem( "authToken" )}`
                    },
                    method: "GET"
                }
            ).then(
                ( data ) => {
                    if( data.status != 200 ) {
                        console.error( "Failed to fetch products", data );
                        return;
                    }

                    data.json().then(
                        ( json ) => {
                            setProducts( json );
                        }
                    );
                }
            );
        },
        []
    );

    return (
        <Dialog open={open} onOpenChange={( _, d ) => setOpen(d.open)}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle
                        action={
                            <DialogTrigger action="close">
                                <Button
                                appearance="subtle"
                                aria-label="close"
                                icon={<Dismiss24Regular />}
                                />
                            </DialogTrigger>
                        }>Change Product</DialogTitle>
                    <DialogContent>
                        <Combobox placeholder="Select product..." style={{ width: "100%" }}>
                            {
                                products.map(
                                    ( product: any ) => (
                                        <Option key={product.id} value={product.id}>
                                            {product.name}
                                        </Option>
                                    )
                                )
                            }
                        </Combobox>
                    </DialogContent>
                    <DialogActions>
                        <Button appearance="primary">Confirm</Button>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Close</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}